import { vocabularioDe } from '../lib/vocabulario.js';
import { fechaLarga, precio, duracion } from '../lib/formato.js';
import { descargarIcs } from '../lib/calendario.js';
import { Tilde, WhatsApp, Descargar, Sobre } from '../componentes/Iconos.jsx';
import { INVITACION } from '../lib/demo.js';

export function Confirmacion({ reserva, negocio: negocioPublico, fecha, timezone, onNuevoTurno, demo = false }) {
  const { turno, servicio, profesional, negocio } = reserva;
  const vocabulario = vocabularioDe(negocio);
  const hora = new Intl.DateTimeFormat('es-AR', {
    hour: '2-digit', minute: '2-digit', hour12: false, timeZone: timezone
  }).format(new Date(turno.inicio));

  // Qué se le promete a la persona depende de por dónde avisa el negocio. Si
  // el canal es sólo WhatsApp, decirle "te mandamos un email" sería mentirle
  // y encima dejarla esperando algo que no va a llegar.
  const avisos = negocioPublico?.avisos ?? { email: true, whatsapp: false };
  const whatsappNegocio = negocioPublico?.whatsapp ?? null;

  function agregarAlCalendario() {
    descargarIcs(
      {
        turno,
        servicio: servicio.nombre,
        profesional: profesional.nombre,
        negocio: negocio.nombre
      },
      `turno-${fecha}.ics`
    );
  }

  const cuando = `${fechaLarga(fecha, timezone)} a las ${hora}`;
  const linkWhatsapp = whatsappNegocio
    ? `https://wa.me/${whatsappNegocio}?text=${encodeURIComponent(
        `Hola ${negocio.nombre}! Te escribo por mi turno del ${cuando}.`
      )}`
    : null;

  return (
    <div className="confirmacion">
      <div className="estado-icono exito">
        <Tilde />
      </div>

      {/* El turno nace confirmado salvo que el negocio revise cada uno a mano.
          Cuando queda pendiente hay que decirlo acá: la persona se va de la
          pantalla creyendo que tiene lugar guardado. */}
      <h1 className="titulo-paso">
        {turno.estado === 'pendiente' ? 'Listo, ya pedimos tu turno' : 'Listo, tu turno quedó reservado'}
      </h1>
      <p className="bajada">
        {turno.estado === 'pendiente'
          ? `Falta que ${negocio.nombre} lo confirme. Te avisamos apenas lo haga.`
          : `Te esperamos en ${negocio.nombre}.`}
      </p>

      <div className="resumen">
        <div className="resumen-fila">
          <span className="resumen-etiqueta">Cuándo</span>
          <span className="resumen-valor destacado">{cuando}</span>
        </div>
        <div className="resumen-fila">
          <span className="resumen-etiqueta">Servicio</span>
          <span className="resumen-valor">
            {servicio.nombre}
            {servicio.precio_centavos > 0 && ` · ${precio(servicio.precio_centavos)}`}
          </span>
        </div>
        <div className="resumen-fila">
          <span className="resumen-etiqueta">{vocabulario.etiquetaTurno}</span>
          <span className="resumen-valor">{profesional.nombre}</span>
        </div>
        {reserva.duracionMinutos && (
          <div className="resumen-fila">
            <span className="resumen-etiqueta">Duración</span>
            <span className="resumen-valor">{duracion(reserva.duracionMinutos)}</span>
          </div>
        )}
      </div>

      {avisos.email && (
        <div className="nota-aviso">
          <Sobre />
          <p>
            Te mandamos un email
            {reserva.email ? <> a <strong>{reserva.email}</strong></> : null} con los
            datos del turno. Ahí adentro está el link por si necesitás cancelar.
            {/* Un turno pendiente no recibe recordatorio hasta que el negocio
                lo confirma, así que no se lo prometemos. */}
            {turno.estado === 'pendiente'
              ? ' Te escribimos de nuevo cuando lo confirmen.'
              : ' Te vamos a escribir de nuevo antes del turno para recordártelo.'}
          </p>
        </div>
      )}

      {avisos.whatsapp && (
        <div className="nota-aviso nota-verde">
          <WhatsApp />
          <p>
            {avisos.email
              ? 'También te llega la confirmación por WhatsApp.'
              : 'Te va a llegar un WhatsApp con la confirmación y un recordatorio antes del turno.'}
          </p>
        </div>
      )}

      {/* El final de la demo. Acá la persona ya vio el producto entero desde
          el lado de su cliente, que es el momento en que mejor se entiende para
          qué sirve: es el lugar donde la invitación al alta pesa más. Va antes
          del botón de WhatsApp porque en la demo ese número es el de una
          barbería que no existe. */}
      {demo && (
        <a className="boton boton-primario demo-invitacion" href="/registro">
          {INVITACION}
        </a>
      )}

      {/* Si no revisa el mail, que igual tenga cómo hablar con el negocio. Es
          el mismo botón que va en el email de confirmación. */}
      {linkWhatsapp && (
        <a
          className="boton boton-whatsapp-publico"
          href={linkWhatsapp}
          target="_blank"
          rel="noreferrer"
        >
          <WhatsApp />
          Escribinos por WhatsApp
        </a>
      )}

      <div className="confirmacion-acciones">
        <button type="button" className="boton boton-secundario" onClick={agregarAlCalendario}>
          <Descargar />
          Agregar a mi calendario
        </button>
        <button type="button" className="boton boton-secundario" onClick={onNuevoTurno}>
          Sacar otro turno
        </button>
      </div>
    </div>
  );
}
